module.exports = __webpack_public_path__ + "static/media/WealthBanner2.f76ca132.png";